import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import './OwnerShipStyle.scss';
import { isNotLoginOrExpired } from '../../../../helpers/Common';
import Lock from '../../../../common/lock/Lock';

const WAIT = 150;

class OwnershipTooltip extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isShowTooltip: false,
      tooltipLeft: null,
      tooltipTop: null,
    };
    this.rootRef = React.createRef();
    this.tooltipRef = React.createRef();
    this.textRef = React.createRef();
    this.div = document.createElement('div');
  }

  componentDidMount() {
    this.table = this.rootRef.current.closest('.scrollbars');
    this.lmItem = this.table.closest('.lm_item');
    this.scrollComponent = this.rootRef.current.closest(
      'table',
    ).parentNode.parentNode;
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { isShowTooltip } = this.state;
    const { tooltipData, user } = this.props;
    if (
      isNotLoginOrExpired(user) &&
      isShowTooltip &&
      !prevState.isShowTooltip
    ) {
      this.setTooltipPosition();
      return;
    }
    const isLoadedData = isShowTooltip && tooltipData && !prevProps.tooltipData;
    const isShowChangeToTrue =
      prevProps.tooltipData &&
      tooltipData &&
      isShowTooltip &&
      !prevState.isShowTooltip;
    if (isLoadedData || isShowChangeToTrue) {
      this.setTooltipPosition();
    }
  }

  componentWillUnmount() {
    clearTimeout(this.timeoutApi);
    window.removeEventListener('mousemove', this.onMouseMove);
  }

  getRealTableHeight = () => {
    const {
      top: tableTop,
      bottom: tableBottom,
      height: tableHeight,
    } = this.table.getBoundingClientRect();
    const { bottom: lmBottom } = this.lmItem.getBoundingClientRect();

    if (tableBottom > lmBottom) {
      return lmBottom - tableTop;
    }

    return tableHeight;
  };

  getTooltipTop = () => {
    let tooltipTop = null;
    const {
      height: tooltipHeight,
    } = this.tooltipRef.current.getBoundingClientRect();
    const {
      bottom: rootBottom,
      top: rootTop,
    } = this.rootRef.current.getBoundingClientRect();
    const realTableHeight = this.getRealTableHeight();
    const { top: tableTop } = this.table.getBoundingClientRect();
    const header = document.querySelector('.header-section');
    if (
      !header ||
      (header &&
        rootTop - tooltipHeight < header.getBoundingClientRect().bottom)
    ) {
      return rootTop;
    }
    if (tooltipHeight < realTableHeight) {
      if (rootBottom + tooltipHeight > tableTop + realTableHeight) {
        tooltipTop = rootTop - tooltipHeight;
      } else {
        tooltipTop = rootTop;
      }
    } else {
      tooltipTop = rootTop - tooltipHeight;
    }

    return tooltipTop;
  };

  getTooltipLeft = () => {
    const { tooltipWidth } = this.props;
    const padding = 100;
    const {
      left: rootLeft,
      right: rootRight,
      width: rootWidth,
    } = this.rootRef.current.getBoundingClientRect();
    const realPadding = Math.min(padding, rootWidth);
    const { right: bodyRight } = document.body.getBoundingClientRect();
    if (rootLeft + realPadding + tooltipWidth > bodyRight) {
      return rootRight - tooltipWidth - realPadding;
    }

    return rootLeft + realPadding;
  };

  setTooltipPosition = () => {
    this.setState({
      tooltipTop: this.getTooltipTop(),
      tooltipLeft: this.getTooltipLeft(),
    });
  };

  onTableScroll = () => {
    this.hideTooltip();
  };

  hideTooltip = () => {
    const { isShowTooltip } = this.state;
    if (isShowTooltip) {
      this.setState({
        isShowTooltip: false,
      });
      document.body.removeChild(this.div);
      window.removeEventListener('mousemove', this.onMouseMove);
      this.scrollComponent.removeEventListener('scroll', this.onTableScroll);
      clearTimeout(this.timeoutApi);
    }
  };

  onMouseMove = e => {
    const isInRoot =
      this.rootRef.current && this.rootRef.current.contains(e.target);
    const isInTooltip =
      this.tooltipRef.current && this.tooltipRef.current.contains(e.target);
    if (isInRoot || isInTooltip) {
      return;
    }
    this.hideTooltip();
  };

  handleMouseOver = e => {
    if (
      e.target !== this.textRef.current &&
      !this.textRef.current.contains(e.target)
    ) {
      return;
    }
    const { fetchData, tooltipData, user } = this.props;
    clearTimeout(this.timeoutApi);
    this.timeoutApi = setTimeout(() => {
      document.body.appendChild(this.div);
      window.addEventListener('mousemove', this.onMouseMove);
      this.setState({
        isShowTooltip: true,
      });
      this.scrollComponent.addEventListener('scroll', this.onTableScroll);

      if (!tooltipData && !isNotLoginOrExpired(user)) {
        fetchData();
      }
    }, WAIT);
  };

  handleMouseLeave = () => {
    clearTimeout(this.timeoutApi);
  };

  renderToolTip = () => {
    const { children, user } = this.props;
    const { tooltipTop, tooltipLeft } = this.state;
    const isLocked = isNotLoginOrExpired(user);

    const extraStyle = isLocked
      ? {
          width: 400,
        }
      : {};

    const tooltipStyle = {
      overflow: 'hidden',
      position: 'fixed',
      maxWidth: tooltipTop ? 1000 : 0,
      top: tooltipTop,
      left: tooltipLeft,
      ...extraStyle,
    };

    return (
      <div
        ref={this.tooltipRef}
        className="tooltip-bubble-ownship"
        style={tooltipStyle}
      >
        {isLocked ? <Lock /> : children}
      </div>
    );
  };

  render() {
    const { isShowTooltip } = this.state;
    const { text } = this.props;

    return (
      <div
        ref={this.rootRef}
        className="tooltip-ownship"
        onMouseOver={this.handleMouseOver}
        onMouseLeave={this.handleMouseLeave}
      >
        {isShowTooltip && ReactDOM.createPortal(this.renderToolTip(), this.div)}
        <div ref={this.textRef} className="company-name">
          {text}
        </div>
      </div>
    );
  }
}

OwnershipTooltip.propTypes = {
  fetchData: PropTypes.func.isRequired,
  text: PropTypes.node.isRequired,
  children: PropTypes.node,
  tooltipWidth: PropTypes.number.isRequired,
};

const mapStateToProps = state => ({
  user: state.userInfo,
});

export default connect(mapStateToProps)(OwnershipTooltip);
